import axios, { AxiosResponse } from "axios";
import { ServerModelWithDateStrings } from "@teamprevent/common/utils";
import * as moment from "moment";

import { TaskModel } from "@teamprevent/common/task/taskActions/models";

import { parseTaskModel } from "../../task/model";

import { HealthSurveillanceOutcomeRecallModel, SetRecallModel, parseHealthSurveillanceOutcomeRecallModel } from "./models";

const buildUrl = (customerId: string, ohCaseId: string, taskId: string) =>
    `/api/${customerId}/ohCase/${ohCaseId}/task/${taskId}/healthSurveillanceRecall`;

const buildEmployeeRecordUrl = (customerId: string, employeeRecordId: string) =>
    `/api/customer/${customerId}/employeeRecord/${employeeRecordId}`;

const getRecallOutcomes = async (customerId: string, ohCaseId: string, taskId: string) => {
    const response = await axios.get<HealthSurveillanceOutcomeRecallModel[]>(`${buildUrl(customerId, ohCaseId, taskId)}/recallOutcomes`);
    return response.data.map(parseHealthSurveillanceOutcomeRecallModel);
};

const getRecallOutcomesForEmployeeRecordId = async (customerId: string, employeeRecordId: string) => {
    const response = await axios.get<HealthSurveillanceOutcomeRecallModel[]>(`${buildEmployeeRecordUrl(customerId, employeeRecordId)}/recallOutcomes`);
    return response.data.map(parseHealthSurveillanceOutcomeRecallModel);
};

const setRecalls = async (customerId: string, ohCaseId: string, taskId: string, model: SetRecallModel[]) => {
    const response = await axios.post<
        ServerModelWithDateStrings<TaskModel>,
        AxiosResponse<ServerModelWithDateStrings<TaskModel>>,
        ServerModelWithDateStrings<{ recalls: SetRecallModel[] }>
    >(
        buildUrl(customerId, ohCaseId, taskId),
        { recalls: model.map(r => ({ ...r, recallDate: r.recallDate.format(moment.HTML5_FMT.DATE) })) }
    );
    return parseTaskModel(response.data);
};

const setEmployeeRecordRecalls = async (customerId: string, employeeRecordId: string, model: SetRecallModel[]) => {
    await axios.post<any, any, ServerModelWithDateStrings<{ recalls: SetRecallModel[] }>>(
        `${buildEmployeeRecordUrl(customerId, employeeRecordId)}/setRecallOutcomes`,
        { recalls: model.map(r => ({ ...r, recallDate: r.recallDate.format(moment.HTML5_FMT.DATE) })) }
    );
};

export const recallApi = { getRecallOutcomes, getRecallOutcomesForEmployeeRecordId, setRecalls, setEmployeeRecordRecalls };
